const Tactic = require('../../entities/Tactic');
const { Age }  = require("../Constants");
const TacticNames = require("../Names/TacticNames");

class MobileArtillery extends Tactic {
    constructor() {
        super(
            Age.Age2,
            TacticNames.MobileArtillery,
            [0, 1, 1],
            "5(3)",
            {}
        )
    }
}

module.exports = MobileArtillery;